import FooterCenteredLayout from './FooterCenteredLayout'

function FooterCenteredLight({ config }) {
  return <FooterCenteredLayout config={config} variant="light" showSocial={false} />
}

export default FooterCenteredLight
